import { render, staticRenderFns } from "./FrontNavigation.vue?vue&type=template&id=85d7218c&scoped=true"
import script from "./FrontNavigation.vue?vue&type=script&lang=js"
export * from "./FrontNavigation.vue?vue&type=script&lang=js"
import style0 from "./FrontNavigation.vue?vue&type=style&index=0&id=85d7218c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d7218c",
  null
  
)

export default component.exports